<template>
   <div class="titleBg">
     <div class="titTxt"><router-link :to="{ path: '/' }"  style="display:block;width:100%;height:100%"><img :src="url + '/img/xaiofei/data1/bt.png'"  /></router-link> </div>
     <img  src="../assets/img/syy.png"  class="return return1"  @click="clickReturn" />
     <div class="returnBox" v-if="nextShow"><router-link :to="{ path: pathUrl }"  ><img src="../assets/img/xyy.png" class="return return2" /></router-link> </div>
     <img :src="url + '/img/zhibo/gx.png'" class="guang1" />
     <img :src="url + '/img/zhibo/gx.png'" class="guang2" />
   </div>
</template>
<script setup  >

import { ref, onMounted, reactive } from "vue";
import * as echarts from "echarts";
import { useRouter } from "vue-router";
// console.log(props)
const props =defineProps({

  pathUrl: {
    type: String,
    default: () => "",
  },
  nextShow: {
    type: Boolean,
    default: () => true,
  },
})
const url = ref("https://lcamapp.oss-accelerate.aliyuncs.com/uploads/img")
const state = reactive({

})
const router = useRouter();
// 返回上一页
function clickReturn(){
  router.go(-1);
}
  onMounted(() => {


  });




</script>
<style lang="less" scoped>
 .titleBg{
   width: 100%;
   height: 554px;
   background: url("@{url}/img/xaiofei/btbj.png")
   no-repeat top center;
   background-size: 100% 100%;
   color: #fff;
   display: flex;
   justify-content: space-between;
   align-items: center;
   position: absolute;
   top: 0;
   left: 0;
   z-index: 0;
   .titTxt {
     width: 2347px;
     height: 93px;
     position: absolute;
     top: 36px;
     left: 50%;
     margin-left: -1173.5px;
     img{
       width: 100%;
       height: 100%;
     }
   }
   .returnBox{
     width:188px;
     height: 84px;
     cursor: pointer;
     position: absolute;
     top: -10px;
     right: 100px;
     z-index: 999;
   }
   .return {
     width:188px;
     height: 84px;
     cursor: pointer;
     position: absolute;
     top: -10px;
     z-index: 999;
   }
   .return1 {
     left: 100px;
   }
   .return2 {
     top: 0;
     right: 0;
   }
   .guang1{
     position: absolute;
     top: -2px;
     left: 0;
     animation: titleGuang1 1.5s linear infinite;
     z-index: 0;
   }
   .guang2{
     position: absolute;
     top: -2px;
     right: 0;
     animation: titleGuang2 1.5s linear infinite;
   }
   @keyframes titleGuang1{
     0%{
       left: -5%;
     }
     100%{
       left: 5%;
     }
   }
   @keyframes titleGuang2{
     0%{
       right: -5%;
     }
     100%{
       right: 5%;
     }
   }
 }
</style>
